module.exports = __webpack_public_path__ + "4b6181217e64e1473cb88ea1473d60f9.svg";